<button (click)="onButtonClick()"
        [color]="color"
        [disabled]="disabled"
        mat-raised-button>
  <ng-content></ng-content>
</button>
